<template>
  <div>
    <h3 class="title is-4">Add user</h3>

    <div class="box has-background-light">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Email address</label>
            <input type="email" class="input" v-model="userEmailAddress" />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Assign to company</label>
            <div class="control is-expanded">
              <div class="select is-fullwidth" :class="{ 'is-loading': companyList.length > 0 }">
                <select v-model="selectedUserCompany">
                  <option value="default">
                    Please select....
                  </option>
                  <option :key="index" :value="company.number" v-for="(company, index) in companyList.companies">
                    {{company.name}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <button :disabled="loading" :class="{ 'is-loading': loading }" class="button" @click="addUserDetails">
          Add user
        </button>
      </div>
    </div>

    <viewCurrentUsers :currentUsers="userList" />
  </div>
</template>

<script>
import errorHandler from '@/errorHandler';
import viewCurrentUsers from '@/components/settings/viewUsers.vue';

export default {
  components: {
    viewCurrentUsers,
  },

  data() {
    return {
      loading: false,
      userEmailAddress: '',
      companyList: [],
      userList: [],
      selectedUserCompany: 'default',
    };
  },

  mounted() {
    this.fetchCompanyDetails();
    this.fetchUsers();
  },

  methods: {
    fetchUsers() {
      fetch('/api/user/list', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.userList = response;
        });
    },

    fetchCompanyDetails() {
      fetch('/api/company/list', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.companyList = response;
        });
    },

    // User Management
    addUserDetails() {
      this.loading = true;

      fetch('/api/user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: this.userEmailAddress, companyID: this.selectedUserCompany }),
      }).then(res => res.json())
        .catch(error => errorHandler(error))
        .then((response) => {
          this.loading = false;
          this.userList.users.push(response);
          this.$awn.success(`User: ${response.email} has been added to company ${response.companyID}`);
        });
    },
  },
};
</script>
